export default "__VITE_ASSET__CNP9nKMb__"